import Footer from 'components/Footer';
import NavigationBar from 'components/NavigationBar';
import styles from './Layout.module.scss';

function Layout({children}: {children: React.ReactNode}) {
  return (
    <div className={styles.layout}>
      <NavigationBar />
      <div className={styles.content}>{children}</div>
      <Footer />
    </div>
  );
}
export default Layout;
